<template>
  <div class="outer-box">
    <h3>Restore Endpoints</h3>
    <div v-if="bigResponse" class="inner-box" style="text-align: left; width: 620px;">
      <h5>Endpoint Response</h5>
      <div v-if="Array.isArray(bigResponse)">
        <p v-for="(response, index) in bigResponse" :key="index">{{ response }}</p>
      </div>
      <div v-else>
        <p>{{ bigResponse }}</p>
      </div>
      <button class="btn btn-success" @click="bigResponse = null">Close</button>
    </div>
    <div v-else class="inner-box" style="text-align: left; width: 620px;">
      <Endpoint v-for="(endpoint, index) in supportEndpoints" :key="index" :endpointObject="endpoint" :loading="loading" />
    </div>

    <multiple-users-modal v-if="showModal" :multiple-users-data="multipleUsersData" @submit="modalSubmit" @close="closeModal"/>
  </div>
</template>

<script>
import Endpoint from '../Endpoint.vue'
import MultipleUsersModal from '../MultipleUsersModal.vue'
import { SpmAppengineService } from "@/services"

export default {
  components: { Endpoint, MultipleUsersModal },
  data() {
    return {
      loading: {},
      bigResponse: null,
      showModal: false,
      multipleUsersData: {
        endpoint: null,
        data: null
      }
    };
  },
  computed: {
    supportEndpoints() {
      return [
        {
          name: "Restore User",
          url: "user/restore/",
          params: [
            {
              value: null,
              placeholder: "User e-mail"
            }
          ],
          action: this.checkForMultipleUsers,
          multipleUsersIsPossible: true,
          bigResponse: false,
          deletedData: true
        },
        {
          name: "Recover All Campaigns",
          info:
            "Recovers ALL of the deleted campaigns from the given Location ID",
          url: "campaigns/recover_all/",
          params: [
            {
              value: null,
              placeholder: "Location ID"
            }
          ],
          action: this.singleParamGetAction
        },
        {
          name: "Restore deleted calendar and events",
          info: "If you want to restore any deleted calendar and it's deleted events, please provider the deleted calendar id.",
          url: "google/calendar/restore_deleted_calendar_and_events_v2_or_v3",
          params: [
            {
              value: null,
              placeholder: "Calendar ID"
            }
          ],
          action: this.restoreDeletedCalendarAndEvents
        },
      ];
    }
  },
  methods: {
    modalSubmit({ endpoint, data }) {
      this.singleParamGetAction(endpoint.name, endpoint.bigResponse, endpoint, data.companyId)
    },
    closeModal(endpointName) {
      this.showModal = false
      this.$set(this.loading, endpointName, false)
    },
    async checkForMultipleUsers(endpointName) {
      this.$set(this.loading, endpointName, true);
      const endpoint = this.supportEndpoints.find(
        endpoint => endpoint.name === endpointName
      );

      if(endpoint.multipleUsersIsPossible) {
        const queryForDeletedData = endpoint.deletedData ? '?deleted_data=true' : ''
        let response
        try {
          response = await SpmAppengineService.checkMultipleUsers(endpoint.params[0].value, queryForDeletedData)
        } catch(error) {
          this.$handleError(error)
        }
        if(Array.isArray(response.data) && response.data.length > 0) {
          this.multipleUsersData = { endpoint, data: response.data }
          this.showModal = true
        } else {
          this.singleParamGetAction(endpointName, endpoint.bigResponse, endpoint)
        }
      } else {
        this.singleParamGetAction(endpointName, endpoint.bigResponse, endpoint)
      }
    },
    singleParamGetAction(endpointName, bigResponse = false, endpoint, companyId) {
      if(!endpoint) endpoint = this.startAction(endpointName)
      let companyQueryParam = ''
      if(companyId) {
        companyQueryParam = `?company_id=${companyId}`
      }
      const url = endpoint.url + endpoint.params[0].value + companyQueryParam;
      this.fireRequest(url, endpointName, bigResponse);
    },
    startAction(endpointName) {
      this.$set(this.loading, endpointName, true);
      return this.supportEndpoints.find(
        endpoint => endpoint.name === endpointName
      );
    },
    fireRequest(url, endpointName, bigResponse = false) {
      SpmAppengineService
      .supportGetRequest(url)
      .then(response => {
        if (bigResponse) this.bigResponse = response.data;
          else alert(response.data.message || JSON.stringify(response.data));
      })
      .catch(error => {
        this.$handleError(error, (error) => {
          if (error.response && error.response.data && error.response.data.message) {
            error = error.response.data.message
          }
          if (bigResponse) this.bigResponse = error;
            else alert(JSON.stringify(error));
        })
      })
    },
    restoreDeletedCalendarAndEvents(endpointName) {
      const endpoint = this.startAction(endpointName);
      const url = endpoint.url + "?calendar_id=" + endpoint.params[0].value
      this.fireRequest(url, endpointName)
    },
  }
};
</script>

<style >

</style>
